import { TravelPolicyModal } from "entities/TravelPolicyModal";
import { userService } from "entities/User";
import { memo, useCallback, useEffect, useState } from "react";
import { useAvailableModules } from "shared/api/hooks/useAvailableModules";
import { userStore } from "entities/User/store/userStore";

function UpdateTravelPolicyModal() {
  const [show, setShow] = useState(false);
  const user = userStore((state) => state.user);
  const updateUser = userStore((state) => state.updateUser);
  const { data: modules } = useAvailableModules();

  const handleSubmit = useCallback(
    async ({ birth_of_place, iss_travel_terms }) => {
      await userService
        .updateProfile(
          {
            ...Object.fromEntries(
              Object.entries({
                iss_travel_terms,
                gdpr: birth_of_place.length > 0,
              }).filter(([, value]) => value)
            ),
            birth_of_place: birth_of_place.length > 0 ? birth_of_place : null,
          },
          {
            onSuccess: "Terms of use were updated",
            catchError: true,
          }
        )
        .then((user) => {
          updateUser(user);
          setShow(false);
        });
    },
    [user.id]
  );

  useEffect(() => {
    if (
      Object.keys(user).length &&
      !user.iss_travel_terms &&
      modules?.user_modules?.TravelPolicy?.available
    ) {
      setShow(true);
    }
  }, [user, modules]);

  return (
    <TravelPolicyModal
      show={show}
      message={
        modules?.user_modules?.TravelPolicy?.additional_data
          ?.travel_policy_message
      }
      handleSubmit={handleSubmit}
      userCountryCode={user?.country_code}
    />
  );
}

export default memo(UpdateTravelPolicyModal);
